import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { useConfig } from "@jti/app-context/useConfig";

import "./Recaptchabar.scss";

const { sanitize } = dompurify;

export type SanitizeConfig = {
  ADD_ATTR: string[];
};

type RecaptchabarProps = {
  className?: string;
  isPaddingRemoved?: boolean;
  sanitizeConfig?: SanitizeConfig;
};

export const Recaptchabar: FC<RecaptchabarProps> = ({ className, isPaddingRemoved, sanitizeConfig = {} }) => {
  const config = useConfig();
  const { __ } = useTranslations();

  return (
    <div className={classNames("recaptchabar", className)} data-testid="recaptchabar">
      <div
        className={classNames("text", {
          paddingRemoved: isPaddingRemoved,
        })}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: sanitize(
              __("recaptchabar.label", [config.reCaptchaPrivacyPolicyUrl, config.reCaptchaTermsOfServiceUrl]),
              sanitizeConfig
            ),
          }}
        />
      </div>
    </div>
  );
};
